export const videoChangeSrc = (video) => {
  const sources = video.querySelectorAll('source');
  sources.forEach(source => {
    if (source.dataset.src) {
      source.src = source.dataset.src;
    }
  });

  video.load();

  video.addEventListener('playing', () => {
    video.classList.add("is-playing");
    video.classList.remove("lazy");
  }, { once: true });
}

export const videoLazyLoading = (lazyVideos) => {
  if ("IntersectionObserver" in window) {
    let lazyVideoObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          videoChangeSrc(entry.target);
          lazyVideoObserver.unobserve(entry.target);
        }
      });
    }, {
      rootMargin: "0px 0px 600px 0px",
      threshold: 0,
    });

    lazyVideos.forEach(function(lazyVideo) {
      lazyVideoObserver.observe(lazyVideo);
    });
  }
}
